export default {
  not_started: 'Set up your payout account — your revenue share is on hold until it is verified.',
  bank_account_missing: 'Add a bank account for payouts — your revenue share is on hold until you do.',
  incomplete: 'Your payout account is not fully verified yet — your revenue share is on hold until it is.',
  add_bank_account: 'Add bank account',
  cta: 'Complete setup',
};
